import React, { FC } from 'react';
import Section from 'evcharging/containers/layout/Section';
import Container from 'evcharging/components/Container';
import Responsible from 'evcharging/components/Responsible';
import Box from 'evcharging/components/Box';
import Title from 'evcharging/components/Title';
import Spacer from 'evcharging/components/Spacer';
import endToEnd from 'evcharging/assets/layout/endToEnd.png';
import Paragraph from 'evcharging/components/Paragraph';
import { CONTACT_US_ANCHOR } from 'evcharging/app/seo/urls';
import LinkButton from 'evcharging/components/LinkButton';
import Image from 'next/image';
import useI18n from 'evcharging/hooks/useI18n';

interface EndToEndProps {
  topSpace?: {
    value: number;
    mobile: number;
  };
}

const EndToEnd: FC<EndToEndProps> = (props) => {
  const { topSpace = { mobile: 0, value: 0 } } = props;
  const { t } = useI18n();

  return (
    <>
      <Spacer {...topSpace} />
      <Section background={'middle'}>
        <Container>
          <Responsible fractions={[50, 50]} space={48} mobileReverse>
            <Box>
              <Title fontSize={32} variant={'h2'}>
                {t('charger.banner.title')}
              </Title>
              <Spacer value={16} />
              <Paragraph color={'middle'} maxWidth={495}>
                {t('charger.banner.body')}
              </Paragraph>
              <Spacer value={24} />
              <LinkButton href={CONTACT_US_ANCHOR}>{t('form.lead.button')}</LinkButton>
            </Box>
            <Image src={endToEnd} alt={t('charger.banner.alt')} width={562} height={297} />
          </Responsible>
        </Container>
      </Section>
    </>
  );
};

export default EndToEnd;
